function SouthSudan({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2181)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M30.7518 9.79706C28.3287 4.04138 22.6367 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L8.69364 9.79706H30.7518Z" fill="black"/>
  <path d="M8.73908 22.1445L4.68677 27.3127C7.58202 30.2083 11.5816 31.9995 15.9999 31.9995C22.6591 31.9995 28.3673 27.9312 30.7764 22.1445H8.73908Z" fill="#496E2D"/>
  <path d="M3.47827 11.7676V20.1733H31.4489C31.8078 18.8426 32 17.4436 32 15.9995C32 14.5343 31.8026 13.1156 31.4337 11.7676H3.47827Z" fill="#A2001D"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#0052B4"/>
  <path d="M5.21157 12.0215L7.16439 14.7465L10.3599 13.7312L8.3717 16.4308L10.3245 19.156L7.14276 18.0993L5.15451 20.7988L5.17638 17.4461L1.99451 16.3893L5.18976 15.374L5.21157 12.0215Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SouthSudan;
